import { string } from "yup";

export default ({ intl, hasAdminPrivileges }) => {
  return hasAdminPrivileges
    ? {
        urlMixerBert: string().nullable(),
        urlRemoteProduction: string().nullable(),
        elasticIp: string().nullable(),
        eventStatus: string(),
      }
    : {};
};
